import React, { useEffect, useMemo, useState } from 'react'
import { Button, Form, Modal } from 'semantic-ui-react'
import { useTextResources } from '../../language'
import PropTypes from 'prop-types'
import CustomerDropDown from '../../components/shared/CustomerDropDown'
import GuestTitlesDropDown from '../../components/shared/GuestTitlesDropDown'
import CountriesDropDown from '../../components/shared/CountriesDropDown'
import StatesDropDown from '../../components/shared/StatesDropDown'
import { GetGuests } from '../../api/services/crm'
const InvoiceDetailsPopup = ({ state, setState, open, ...rest }) => {
    const text = useTextResources()
    const [innerState, setInnerState] = useState({ ...state })
    const [innerOpen, setInnerOpen] = useState(open)
    const [states, setStates] = useState([])
    const CustomersSpec = React.useMemo(() => {
        return { GetOnlyCustomerArray: true, IsActive: true, IncludeCustomerTypeId: true }
    }, [])

    useEffect(() => {
        setInnerState({ ...state })
    }, [state])

    useEffect(() => {
        setInnerOpen(open)
    }, [open])

    return <Modal open={innerOpen} onClose={() => setInnerOpen(false)} onOpen={() => setInnerOpen(true)} {...rest}>
        <Modal.Header>{text("InvoiceDetails")}</Modal.Header>
        <Modal.Content>
            <Form>
                <Form.Field control={CustomerDropDown} clearable spec={CustomersSpec} label={text("Customer")}
                    value={innerState.customerId}
                    onChangeItem={async item => {
                        const [guest] = await GetGuests({
                          IDs: item.DefaultGuestProfileId,
                          IncludeLocation: true
                        });
                        setInnerState({
                          ...innerState,
                          customerId: item?.Id,
                          customerName: item?.Name,
                          vat: item?.VatNumber,
                          fname: null,
                          lname: null,
                          countryId: guest?.Location?.CountryID,
                          stateId: guest?.Location?.StateID,
                          street: guest?.Location?.StreetAndHomeNumber,
                          city: guest?.Location?.City,
                          zip: guest?.Location?.Zip,
                        });
                    }} />
                {!innerState.customerId && <Form.Group>
                    <Form.Field width="2" label={text("Salutation")} control={GuestTitlesDropDown} onChangeItem={item => {
                        setInnerState({
                            ...innerState,
                            salutation: item && item.Name
                        })
                    }} />
                    <Form.Input width="6" label={text("FirstName")} value={innerState.fname} onChange={(e, { value }) => setInnerState({
                        ...innerState,
                        fname: value
                    })}></Form.Input>
                    <Form.Input width="6" label={text("LastName")} value={innerState.lname} onChange={(e, { value }) => setInnerState({
                        ...innerState,
                        lname: value
                    })}></Form.Input>
                    <Form.Input width="2" label={text("VatNumber")} value={innerState.vat} onChange={(e, { value }) => setInnerState({
                        ...innerState,
                        vat: value
                    })}></Form.Input>
                </Form.Group>}
                {!innerState.customerId && <Form.Group widths="equal">
                    <Form.Input label={text("Email")} value={innerState.email} onChange={(e, { value }) => setInnerState({
                        ...innerState,
                        email: value
                    })}></Form.Input>
                    <Form.Input label={text("Phone")} value={innerState.phone} onChange={(e, { value }) => setInnerState({
                        ...innerState,
                        phone: value
                    })}></Form.Input>
                     <Form.Input label={text("GuestIdentityCardNumber")} value={innerState.idnumber} onChange={(e, { value }) => setInnerState({
                        ...innerState,
                        idnumber: value
                    })}></Form.Input>
                </Form.Group>}
                <Form.Group widths="equal">
                    <Form.Field label={text("Country")} control={CountriesDropDown} value={innerState.countryId} spec={useMemo(() => {
                        return {
                            IncludeStates: true
                        }
                    }, [])} onChangeItem={item => {
                        setInnerState({
                            ...innerState,
                            country: item.Name,
                            countryId: item.Id,
                            state: "",
                            stateId: null
                        })
                        setStates(item.States)
                    }} />
                    <Form.Field disabled={states.length === 0} label={text("State")} value={innerState.stateId} data={states} control={StatesDropDown} onChangeItem={item=>{
                        setInnerState({
                            ...innerState,
                            state: item.Name,
                            stateId: item.Id
                        })
                    }}/>
                </Form.Group>
                <Form.Group>
                    <Form.Input width="6" label={text("Street")} value={innerState.street} onChange={(e, { value }) => setInnerState({
                        ...innerState,
                        street: value
                    })}></Form.Input>
                    <Form.Input width="6" label={text("City")} value={innerState.city} onChange={(e, { value }) => setInnerState({
                        ...innerState,
                        city: value
                    })}></Form.Input>
                    <Form.Input width="4" label={text("ZipCode")} value={innerState.zip} onChange={(e, { value }) => setInnerState({
                        ...innerState,
                        zip: value
                    })}></Form.Input>
                </Form.Group>
            </Form>
        </Modal.Content>
        <Modal.Actions>
            <Button negative onClick={() => setInnerOpen(false)}>{text("Close")}</Button>
            <Button positive onClick={() => {
                setState({ ...innerState })
                setInnerOpen(false)
            }}>{text("Apply")}</Button>
        </Modal.Actions>
    </Modal>
}

InvoiceDetailsPopup.propTypes = {
    state: PropTypes.object,
    setState: PropTypes.func,
    open: PropTypes.bool
}

export default InvoiceDetailsPopup
